module.exports = {
  red: 'rgba(203, 0, 24, 1)',
  redLight: 'rgba(239, 87, 83, 1)',
  redLightest: 'rgba(252, 235, 234, 1)',
  black: 'rgba(34, 41, 47, 1)',
  grey: 'rgba(184, 194, 204, 1)',
  greyLightest: 'rgba(248, 250, 252, 1)',
  greyLighter: 'rgba(241, 245, 248, 1)',
  greyLight: 'rgba(218, 225, 231, 1)',
  greyDark: 'rgba(135, 149, 161, 1)',
  greyDarker: 'rgba(96,111, 123, 1)',
  greyDarkest: 'rgba(61, 72, 82, 1)',
  indigo: 'rgba(101, 116, 205, 1)',
  indigoLight: 'rgba(120, 134, 215, 1)',
  indigoLightest: 'rgba(230, 232, 255, 1)',
  blueLightest: 'rgba(239, 248, 255, 1)',
  blue: 'rgba(52, 144, 220, 1)',
  blueDarker: 'rgba(28, 61, 90, 1)',
  teal: 'rgba(77, 192, 181, 1)',
  white: 'rgba(255, 255, 255, 1)',
  whiteLight: 'rgba(19, 19, 19, 0.479)',
  greenLightest: 'rgba(227, 252, 236, 1)',
  green: 'rgba(59, 193, 114, 1)',
  yellowLighter: 'rgba(255, 249, 194, 1)',
  yellow: 'rgba(255, 193, 37, 1)',
  yellowDark: 'rgba(242, 208, 36, 1)',
  orangeLight: 'rgba(250, 173, 99, 1)',
  orange: 'rgba(246, 153, 63, 1)',
  wash: 'rgba(245, 248, 252, 1)',
  genericWash: 'rgba(230, 236, 247, 1)',
};



// WEBPACK FOOTER //
// ../shared/optilit-themes/src/ou-theme.js